/**
 * Helpers for creating DocumentReminders instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { DocumentRemindersConfig } from "le-coffre-resources/dist/Notary";
import {
	createCreateConfigMethod,
	createGetConfigMethod,
	createUpdateConfigMethod,
	createDeleteConfigMethod,
	createGetOfficeConfigsMethod,
	createTriggerRemindersMethod,
	createCountMethod,
	createGetMethod,
	type UpdateConfigParams,
} from "./documentRemindersMethodsHelpers";

export interface DocumentRemindersInstance {
	createConfig(
		documentTypeUid: string,
		reminderIntervals: number[],
		reminderMessage?: string,
		autoSend?: boolean,
	): Promise<DocumentRemindersConfig>;
	getConfig(documentTypeUid: string): Promise<DocumentRemindersConfig>;
	updateConfig(documentTypeUid: string, params: UpdateConfigParams): Promise<DocumentRemindersConfig>;
	deleteConfig(documentTypeUid: string): Promise<{ message: string }>;
	getOfficeConfigs(officeUid: string): Promise<DocumentRemindersConfig[]>;
	triggerReminders(): Promise<{ message: string; count: number }>;
	count(query?: unknown): Promise<{ count: number }>;
	get(query?: unknown): Promise<DocumentRemindersConfig[]>;
}

/**
 * Create DocumentReminders instance with all methods
 */
export function createDocumentRemindersInstance(baseNotary: IBaseNotary): DocumentRemindersInstance {
	return {
		createConfig: createCreateConfigMethod(baseNotary),
		getConfig: createGetConfigMethod(baseNotary),
		updateConfig: createUpdateConfigMethod(baseNotary),
		deleteConfig: createDeleteConfigMethod(baseNotary),
		getOfficeConfigs: createGetOfficeConfigsMethod(baseNotary),
		triggerReminders: createTriggerRemindersMethod(baseNotary),
		count: createCountMethod(),
		get: createGetMethod(),
	};
}
